import React from "react";
 
const PayrollIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      className="size-6 stroke-2"
    >
      <g>
        <path
          d="M481 0H218.785L120 98.785V182c-49.625 0-90 40.375-90 90s40.375 90 90 90 90-40.375 90-90c0-39.11-25.078-72.469-60-84.852V120h90V30h211v392H223.89c-20.777-35.84-59.566-60-103.89-60C53.832 362 0 415.832 0 482v30h240v-30c0-10.355-1.32-20.406-3.797-30H481zM180 272c0 33.086-26.914 60-60 60s-60-26.914-60-60 26.914-60 60-60 60 26.914 60 60zm-8.785-182L210 51.215V90zM30 482c0-49.625 40.375-90 90-90s90 40.375 90 90zm0 0"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
          className="stroke-2"
        ></path>
        <path
          d="M345 212c-8.27 0-15-6.73-15-15h-30c0 19.555 12.54 36.227 30 42.422V272h30v-32.578c17.46-6.195 30-22.867 30-42.422 0-11.953-4.598-23.348-12.945-32.078C368.473 155.945 357.09 151 345 151c-7.992 0-15-7.477-15-16 0-8.27 6.73-15 15-15s15 6.73 15 15h30c0-19.555-12.54-36.227-30-42.422V60h-30v32.578c-17.46 6.195-30 22.867-30 42.422 0 11.953 4.598 23.348 12.945 32.078C321.527 176.055 332.91 181 345 181c7.992 0 15 7.477 15 16 0 8.27-6.73 15-15 15zM240 362h181v30H240zM240 302h181v30H240zm0 0"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
          className="stroke-2"
        ></path>
      </g>
    </svg>
  );
};
 
export default PayrollIcon;